export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    slots: {
      default: 'opt',
    },
  },
  {
    type: 'expand',
    width: 70,
    align: 'center',
    title: that.$l('table_label_expand') || '展开',
    slots: {
      content: 'expandContent',
    },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_order_goods_no') || '订单产品编号',
    field: 'orderGoodsNo',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_order_goods_name') || '订单产品名称',
    field: 'orderGoodsName',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_goods_spec_no') || '产品规格编号',
    field: 'orderGoodsSpecNo',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_goods_spec_name') || '产品规格名称',
    field: 'orderGoodsSpecName',
    minWidth: 200,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_identify_No') || '标识号',
    field: 'identifyNo',
    minWidth: 200,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    field: 'modifyByName',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
